import React from 'react';
import IntlTelInput from 'react-intl-tel-input';

export default (props) => {
  const { disabled, onChange, ...otherProps } = props;

  // The country code is supplied by the selected flag (disableCountryCode is on), so
  // the field must hold a *national* number only. When a user types a number in
  // international form (leading "+" or "00"), libphonenumber validates it against the
  // number's OWN country and ignores the selected flag — e.g. "00201120131437" is a
  // valid Egyptian number, so `isValid` returns true while the Saudi (966) flag is
  // still selected. The backend then concatenates 966 + 201120131437 → "966201120131437".
  // Treat any international-prefixed input as invalid for the selected country.
  const handlePhoneNumberChange = (isValid, value, ...rest) => {
    const raw = (value || '').trim();
    const isInternationalFormat = raw.startsWith('+') || raw.startsWith('00');
    onChange?.(isValid && !isInternationalFormat, value, ...rest);
  };

  return (
    <>
      <IntlTelInput
        onPhoneNumberChange={handlePhoneNumberChange}
        onPhoneNumberBlur={props.onBlur}
        preferredCountries={props.preferredCountries || ['sa', 'eg', 'ps']}
        disableCountryCode
        onlyCountries={props.onlyCountries}
        inputClassName="tel-input"
        containerClassName="tel-input-container intl-tel-input tel-wrapper"
        {...otherProps}
        {...(disabled && { placeholder: 'يرجى إكمال التحقق' })}
        disabled={disabled}
      />
    </>
  );
};